var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "create-comment-config" }, [
    _c(
      "div",
      { staticClass: "config-field" },
      [
        _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.commentText")))]),
        _vm._v(" "),
        _c("a-textarea", {
          attrs: {
            placeholder: _vm.$t(
              "taskModuleRules.enterCommentTextWithDynamicVariables"
            ),
            rows: 4,
          },
          on: { change: _vm.emitChange },
          model: {
            value: _vm.localConfig.comment,
            callback: function ($$v) {
              _vm.$set(_vm.localConfig, "comment", $$v)
            },
            expression: "localConfig.comment",
          },
        }),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("taskModuleRules.dynamicVariablesExample")) +
              "\n        "
          ),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }